<script setup>
import { computed } from 'vue';
import { categoryLabel, categoryDot } from '../utils/contentCategories.js';

const props = defineProps({
  data: { type: Array, default: () => [] },
});

const maxTotal = computed(
  () => Math.max(1, ...props.data.map(d => d.total || 0))
);

const sentimentNet = item => {
  const s = item.sentiment || {};
  const total = (s.positive || 0) + (s.negative || 0) + (s.neutral || 0);
  if (!total) return 0;
  return Math.round(((s.positive - s.negative) / total) * 100);
};
</script>

<template>
  <div class="rounded-xl border border-n-weak bg-n-background p-4">
    <h3 class="mb-3 text-sm font-semibold text-n-slate-12">
      Taxonomia de Conteúdo
    </h3>

    <div v-if="!data.length" class="py-6 text-center text-sm text-n-slate-11">
      Sem posts classificados ainda. A taxonomia é aplicada em novas coletas.
    </div>

    <div v-else class="overflow-x-auto">
      <table class="w-full text-xs">
        <thead>
          <tr class="border-b border-n-weak text-left text-[10px] uppercase tracking-wide text-n-slate-11">
            <th class="py-2 pr-2">Categoria</th>
            <th class="py-2 pr-2 text-right">Posts</th>
            <th class="py-2 pr-2">Volume</th>
            <th class="py-2 pr-2 text-right">Eng/post</th>
            <th class="py-2 pr-2 text-center">+</th>
            <th class="py-2 pr-2 text-center">-</th>
            <th class="py-2 pr-2 text-right">Sent. Net</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="b in data"
            :key="b.category"
            class="border-b border-n-weak last:border-none"
          >
            <td class="py-2 pr-2">
              <span class="inline-flex items-center gap-1.5 text-[11px] font-medium text-n-slate-12">
                <span :class="categoryDot(b.category)" class="size-2 rounded-full" />
                {{ categoryLabel(b.category) }}
              </span>
            </td>
            <td class="py-2 pr-2 text-right font-semibold text-n-slate-12">
              {{ b.total }}
            </td>
            <td class="py-2 pr-2">
              <div class="h-1.5 w-full overflow-hidden rounded-full bg-n-slate-3">
                <div
                  class="h-full rounded-full bg-blue-500"
                  :style="{ width: `${Math.round((b.total / maxTotal) * 100)}%` }"
                />
              </div>
            </td>
            <td class="py-2 pr-2 text-right text-n-slate-11">
              {{ Math.round(b.avgEngagement || 0) }}
            </td>
            <td class="py-2 pr-2 text-center text-emerald-600">
              {{ b.sentiment?.positive || 0 }}
            </td>
            <td class="py-2 pr-2 text-center text-rose-600">
              {{ b.sentiment?.negative || 0 }}
            </td>
            <td
              class="py-2 pr-2 text-right font-semibold"
              :class="sentimentNet(b) > 0 ? 'text-emerald-600' : sentimentNet(b) < 0 ? 'text-rose-600' : 'text-n-slate-11'"
            >
              {{ sentimentNet(b) > 0 ? '+' : '' }}{{ sentimentNet(b) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
